export const transferRecordTable = {
  headers: {
    originalUnit: '原本單位',
    departureDate: '移出日期',
    transferUnit: '轉移單位',
    receptionDate: '接收日期',
  },
  pendingReceive: '待接收',
}
